import { AccountTopic } from "./Account.ts"
import type { TopicFamily, TopicOf } from "./TopicFamily.ts"

export * from "./Account.ts"
export * from "./TopicFamily.ts"

/**
 * Every topic family. Adding one (Bars, Quotes, …) is a new file here, one entry
 * in this list, and one producer in the backend's TopicHub layer.
 */
export const TOPIC_FAMILIES = [AccountTopic] as const

/** Any family's decoded topic (the Type of WsProtocol's `Topic`). */
export type AnyTopic = TopicOf<(typeof TOPIC_FAMILIES)[number]>

const byTag: ReadonlyMap<string, TopicFamily> = new Map(TOPIC_FAMILIES.map((family) => [family.tag, family]))

/** The family a topic belongs to; undefined for a tag no family registers. */
export const familyOf = (topic: { readonly _tag: string }): TopicFamily | undefined => byTag.get(topic._tag)

/** A topic's key, e.g. "account:acc_1"; undefined for a tag no family registers. */
export const topicKey = (topic: AnyTopic): string | undefined => familyOf(topic)?.key(topic)
